import { useHotel } from './workspace-context';
import { useNavigation } from './navigation';

export function useScope() {
    const hotel = useHotel();
    const navigation = useNavigation();
    const requested = navigation.params.get('property');
    const propertyID = requested === 'all' ? 'all' : hotel.data.properties.find(value => value.id === requested)?.id ?? hotel.data.properties[0]?.id ?? 'all';
    const property = hotel.data.properties.find(value => value.id === propertyID);
    const includes = (id: string) => propertyID === 'all' || id === propertyID;
    return {
        ...hotel, ...navigation, propertyID, property,
        rooms: hotel.data.rooms.filter(value => includes(value.property_id)),
        plans: hotel.data.rate_plans.filter(value => includes(value.property_id)),
        reservations: hotel.data.reservations.filter(value => includes(value.offer.property_id)),
        contracts: hotel.data.contracts.filter(value => includes(value.property_id)),
    };
}
